import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaSignInAlt, FaUserPlus, FaBars, FaTimes } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import { useNotification } from '../../hooks/useNotification';
import { useLogout } from '../../hooks/useLogout';
import styles from './styles/Header.module.css';

export default function Header() {
    const { user } = useContext(AuthContext);
    const { showNotification } = useNotification();
    const { handleLogout } = useLogout();
    const [loading, setLoading] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const onLogout = async () => {
        setLoading(true);

        try {

            await handleLogout();

            showNotification('Déconnexion réussie', 'success');
            setMobileMenuOpen(false);
        } catch (error) {
            console.error('Erreur déconnexion:', error);
            showNotification(`Erreur: ${error.message}`, 'error');
            setLoading(false);
        }
    };

    // Fonction pour scroller vers une section
    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setMobileMenuOpen(false); // Fermer le menu après clic
        }
    };

    // Fermer le menu quand on clique sur un lien
    const handleNavClick = () => {
        setMobileMenuOpen(false);
    };

    return (
        <header className={styles.header}>
            <div className={styles.container}>
                {/* Logo */}
                <Link to="/" className={styles.logo} onClick={handleNavClick}>
                    <img src="/images/og-image.jpeg" alt="OV Hairstyle" />
                </Link>

                {/* Mobile Navigation */}
                <nav className={`${styles.nav} ${mobileMenuOpen ? styles.navOpen : ''}`}>
                    {/* Mobile Actions - Appear inside the menu */}
                    <div className={styles.mobileActions}>
                        {user ? (
                            <>
                                <span className={styles.mobileUserName}>
                                    <FaUser /> {user.displayName || user.email}
                                </span>
                                <button
                                    className={styles.mobileLogoutBtn}
                                    onClick={onLogout}
                                    disabled={loading}
                                >
                                    <FaSignOutAlt />
                                    {loading ? 'Déconnexion...' : 'Déconnexion'}
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" className={styles.mobileLoginBtn} onClick={handleNavClick}>
                                    <FaSignInAlt /> Connexion
                                </Link>
                                <Link to="/register" className={styles.mobileRegisterBtn} onClick={handleNavClick}>
                                    <FaUserPlus /> S'inscrire
                                </Link>
                            </>
                        )}
                    </div>

                    {/* Navigation Links */}
                    <Link to="/" className={styles.navLink} onClick={handleNavClick}>
                        Accueil
                    </Link>

                    <button
                        className={styles.navLink}
                        onClick={() => scrollToSection('services')}
                        type="button"
                    >
                        Services
                    </button>

                    <button
                        className={styles.navLink}
                        onClick={() => scrollToSection('process')}
                        type="button"
                    >
                        Comment ?
                    </button>

                    <button
                        className={styles.navLink}
                        onClick={() => scrollToSection('faq')}
                        type="button"
                    >
                        FAQ
                    </button>

                    {/* Sections visibles SEULEMENT si l'utilisateur n'est PAS connecté */}
                    {!user && (
                        <>
                            <button
                                className={styles.navLink}
                                onClick={() => scrollToSection('benefits')}
                                type="button"
                            >
                                Avantages
                            </button>
                            <button
                                className={styles.navLink}
                                onClick={() => scrollToSection('testimonials')}
                                type="button"
                            >
                                Témoignages
                            </button>

                        </>
                    )}

                    {/* Liens utilisateur - Visibles SEULEMENT si connecté */}
                    {user && (
                        <>
                            <Link to="/reservation" className={styles.navLink} onClick={handleNavClick}>
                                Réservation
                            </Link>
                            <Link to="/profile" className={styles.navLink} onClick={handleNavClick}>
                                Profil
                            </Link>
                        </>
                    )}
                </nav>

                {/* Desktop Actions */}
                <div className={styles.desktopActions}>
                    {user ? (
                        <>
                            <span className={styles.userName}>
                                <FaUser /> {user.displayName || user.email}
                            </span>
                            <button
                                className={styles.logoutBtn}
                                onClick={onLogout}
                                disabled={loading}
                            >
                                <FaSignOutAlt />
                                {loading ? 'Déconnexion...' : 'Déconnexion'}
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className={styles.loginBtn} onClick={handleNavClick}>
                                <FaSignInAlt /> Connexion
                            </Link>
                            <Link to="/register" className={styles.registerBtn} onClick={handleNavClick}>
                                <FaUserPlus /> S'inscrire
                            </Link>
                        </>
                    )}
                </div>

                {/* Hamburger Button */}
                <button
                    className={styles.hamburger}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    {mobileMenuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </div>

            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div
                    className={styles.mobileOverlay}
                    onClick={() => setMobileMenuOpen(false)}
                />
            )}
        </header>
    );
}
